import { observer } from 'mobx-react';
import { useStores } from '@/hooks/use-stores';

import { RulesOverviewContainer } from './styled';
import Range from '../Common/Range/Range';
import { RangeType } from '../Common/Range/Range.utils';
import { t } from 'i18next';
import { Alert } from 'antd';
import React from 'react';
import { EngineStore } from '@/store/Engine/EngineStore';
import { versionTabs } from '@/comp/pages/EnginePage/Engine/CentrifugalCompressors/CentrifugalCompressors.utils';

const RulesOverview = observer(
  ({
    hasTriedToSubmit,
    activeParentTab,
  }: {
    hasTriedToSubmit?: boolean;
    activeParentTab: keyof typeof versionTabs;
  }) => {
    const { engineStore }: { engineStore?: EngineStore } = useStores();

    const {
      mainRangesConfiguration: { flowLevels, pressureLevels, unit },
      setpointsConfiguration,
    } = engineStore;

    return (
      <RulesOverviewContainer>
        {activeParentTab === versionTabs.draft && (
          <div className="order-notification-container">
            <Alert message={t('compressorSetpointsOrderInfo')} type="info" showIcon />
          </div>
        )}
        {flowLevels?.ranges?.map((flowLevel, flowIndex) => {
          const pressureRangesByFlow = pressureLevels.getPressureRangesByFlow(flowLevel?.key);
          const setpointsByPressureRanges = pressureRangesByFlow?.reduce(
            (result, pressureRange) => ({
              ...result,
              [pressureRange?.key]: setpointsConfiguration.getSetpointsByPressureRange(pressureRange?.key),
            }),
            {},
          );
          return (
            <div className="flex-row" key={flowLevel?.key} id="flow-level">
              {Object.values(setpointsByPressureRanges)?.some(
                (setpointsByPressureRange: unknown[]) => setpointsByPressureRange?.length,
              ) && <Range range={flowLevel} unit={unit} type={RangeType.Flow} />}
              <div className="pressure-ranges">
                {pressureRangesByFlow?.map(pressureLevel =>
                  setpointsByPressureRanges[pressureLevel?.key]?.length ? (
                    <Range
                      key={pressureLevel?.key}
                      range={pressureLevel}
                      unit={unit}
                      type={RangeType.Pressure}
                      setpoints={setpointsByPressureRanges[pressureLevel?.key]}
                      flowIsFirst={flowIndex === 0}
                      hasTriedToSubmit={hasTriedToSubmit}
                    />
                  ) : null,
                )}
              </div>
            </div>
          );
        })}
      </RulesOverviewContainer>
    );
  },
);

export default RulesOverview;
